import React from "react";
import { SanityRawContent } from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import styles from "./SimpleTable.module.scss";

type KeyedValue<T> = T & { _key: string };

type KeyedArray<T> = Array<KeyedValue<T>>;

interface SanitySimpleTable {
  content: KeyedArray<SanitySimpleTableRow>;
}

interface SanitySimpleTableRow {
  content: KeyedArray<SanitySimpleTableCell>;
}

interface SanitySimpleTableCell {
  content: SanityRawContent;
}

const SimpleTable = ({ node }: { node: SanitySimpleTable }) => {
  const header: SanitySimpleTableRow | undefined = node.content[0];

  return (
    <table className={styles.root}>
      <thead>{header && <SimpleTableRow value={header} as="th" />}</thead>
      <tbody>
        {node.content.slice(1).map(value => (
          <SimpleTableRow key={value._key} value={value} as="td" />
        ))}
      </tbody>
    </table>
  );
};

const SimpleTableRow = ({
  value,
  as
}: {
  value: SanitySimpleTableRow;
  as: "th" | "td";
}) => (
  <tr>
    {value.content.map(cell => (
      <SimpleTableCell key={cell._key} value={cell} as={as} />
    ))}
  </tr>
);

const SimpleTableCell = ({
  value,
  as: Tag
}: {
  value: SanitySimpleTableCell;
  as: "th" | "td";
}) => (
  <Tag>
    <BlockContent
      content={value.content}
      bodyVariant={Tag === "td" ? "defaultLight" : "defaultBold"}
    />
  </Tag>
);

export default SimpleTable;
